//
// Winline batcher
//
// Takes an object from the server that describes a win and batches it into animation sequences

winlineBatcherLowWin = {};
winlineBatcherLowWin.useWildSymbolAnim = false;

winlineBatcherLowWin.batch = function (winData, controllerName, slotMachine) {
  let res = [];
  //let symbolSound = "Extra spins spinning";

  // if (typeof (symbolTemplate.soundFile) !== "undefined") {

  let rand = Math.floor(Math.random() * 3) + 1;
  let smallWinSound = `smallWin${rand}`;
  let symbolAnimations = [];
  for (let i = 0; i < winData.winningLines.length; ++i) {
    for (let j = 0; j < winData.winningLines[i].occurrences; ++j) {
      var row = winData.winningLines[i].positions[j].row;
      var reel = winData.winningLines[i].positions[j].reel;
      // Check for unqique
      var unique = true;
      for (let m = 0; m < symbolAnimations.length; ++m) {
        if (
          symbolAnimations[m].reel == reel &&
          symbolAnimations[m].row === row
        ) {
          unique = false;
        }
      }

      if (unique) {
        symbolAnimations.push({
          reel: reel,
          row: row,
          symbolIndex: winData.winningLines[i].symbol.ids[j],
          value: winData.winningLines[i].symbol.value,
          multiplier: 1,
        });
      }
    }
  }

  //find symbol sound
  let maxSymValueIdx = Math.max.apply(
    Math,
    symbolAnimations.map(function (obj) {
      return obj.symbolIndex;
    })
  );

  var symbolSound =
    resourceManager.getConfiguration().symbols[
      Object.keys(resourceManager.getConfiguration().symbols)[maxSymValueIdx]
    ].soundFile;

  res.push({
    type: "Symbol",
    sound: symbolSound,
    data: symbolAnimations,
    slotMachine: slotMachine,
  });
  return res;
};

winlineBatcherLowWin.setUseWildSymbolAnim = function (val) {
  winlineBatcherLowWin.useWildSymbolAnim = val;
};

resourceManager.registerPlugIn("winlineBatcherLowWin", winlineBatcherLowWin);
